<template>

<div>
    <div id="figures" v-if="location == 1">
        <img src="/assets/img/figures-g-green-hor.svg" class="figure girl-green" />
        <img src="/assets/img/figures-g-yellow-hor.svg" class="figure girl-yellow" />
        <img src="/assets/img/figures-g-b-hor.svg" class="figure girl-boy" />
        <img src="/assets/img/figures-b-g-hor.svg" class="figure boy-girl" />
    </div>

     <div id="figures" v-if="location == 2">
        <img src="/assets/img/figures-g-green-kus.svg" class="figure girl-green" />
        <img src="/assets/img/figures-g-yellow-kus.svg" class="figure girl-yellow" />
        <img src="/assets/img/figures-g-b-kus.svg" class="figure girl-boy" />
        <img src="/assets/img/figures-b-g-kus.svg" class="figure boy-girl" />
    </div>


    <div class="page-wrapper-inner">

        <div class="block">

            <div>
                <label class="subtitle horgen" v-if="location == 1">Horgen</label>
                <label class="subtitle kuesnacht"  v-if="location == 2">Küsnacht</label>
                <h2>Day Care</h2>
                <p>{{ trans.daycare.intro1[lang] }}</p>
                <p>{{ trans.daycare.intro2[lang] }}</p>
                <ul class="link-block">
                    <!-- <li><a href="#" class="more">{{ trans.global.organisation[lang] }} +</a></li> -->
                    <li>
                        <a v-if="location == 1" target="_blank" :href="trans.global['kuendigung_url.ho'][lang]" class="more">{{ trans.global.terms[lang] }} +</a>
                        <a v-if="location == 2" target="_blank" :href="trans.global['kuendigung_url.ku'][lang]" class="more">{{ trans.global.terms[lang] }} +</a>
                    </li>
                </ul>
            </div>

            <section v-if="dataIsInit" >



                <ul class="optionlist ">
                    <li>
                        <p-check v-model="area.before" class="p-default p-round p-fill level1">{{ trans.global.before_school[lang] }}</p-check>
                        <div  v-bind:class="[{'active':area.before} , 'hidebox']" >
                            <div class="info">{{ trans.daycare.choose_between[lang] }}</div>
                            <ul class="block-list">
                                <li>
                                    <div>
                                        <p-radio name="before-day-week" @change="checkConditions" :value="config.serviceIdWeekBefore" v-model="selectionOptions[0].timeranges.before" class="p-default p-round p-fill level2">{{ trans.global.alldays[lang] }} </p-radio>
                                    </div>
                                    <span>{{ trans.global.from[lang] }} 07:30 bis 08:30</span>
                                    <span>{{ trans.global.chf_month[lang] }}</span>
                                    <em v-bind:class="{disabled:!selectionOptions[0].timeranges.before}">{{ weekBeforeService.relevantPrice.price | francs }}</em>
                                </li>
                                <li>
                                    <div>
                                        <p-radio name="before-day-week" @change="checkConditions" :value="false" v-model="selectionOptions[0].timeranges.before" class="p-default p-round p-fill level2">{{ trans.global.some_days[lang] }}</p-radio>
                                    </div>
                                    <em v-bind:class="{disabled:selectionOptions[0].timeranges.before}">{{ priceBeforeDays | francs }}</em>

                                    <div v-if="selectionOptions[0].timeranges.before === false" class="noflex pills">
                                        <p class="info">{{ trans.daycare.choose_days[lang] }} (<i v-if="location==1">63.–</i><i v-if="location==2">50.–</i> {{ trans.global.chf_month[lang] }})</p>
                                        <button  v-for="day in days" :key="day.id" @click="selectionOptions[day.id].timeranges.before = !selectionOptions[day.id].timeranges.before"
                                        v-bind:class="[{ active: selectionOptions[day.id].timeranges.before }, 'pill']"><i>{{ day.name }}</i></button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p-check v-model="area.after" class="p-default p-round p-fill level1">{{ trans.global.after_school[lang] }}</p-check>

                        <div v-bind:class="[{'active':area.after} , 'hidebox']" >
                            <div class="info" v-if="location==1 && lang=='de'">Bitte gewünschte Zeiten auswählen. Alle Optionen sind inklusive Mittwochnachmittag ab 12h.</div>
                            <div class="info" v-if="location==1 && lang=='en'">Please select desired times. All options are inclusive Wednesday afternoon as of 12.00.</div>

                            <div class="info" v-if="location==2 && lang=='de'">Bitte gewünschte Zeiten auswählen. Alle Optionen sind inklusive Mittwochnachmittag ab 12:00 h.</div>
                            <div class="info" v-if="location==2 && lang=='en'">Please select desired times. All options are inclusive Wednesday afternoon as of 12.00.</div>

                            <ul class="block-list">
                                <li>
                                    <div>
                                        <p-radio @change="checkConditions" type="radio" name="after-day-week" id="afterweek" :value="config.serviceIdWeekAfter" class="p-default p-round p-fill level2" v-model="selectionOptions[0].timeranges.after">
                                            {{ trans.global.alldays[lang] }} {{ trans.global.until[lang] }}
                                            <span v-if="location==1">17:30</span><span v-if="location==2">17:30</span>
                                        </p-radio>
                                    </div>
                                    <span>{{ trans.global.from[lang] }}
                                        <i v-if="location==1">15:45</i><i v-if="location==2">15:30</i>
                                         {{ trans.global.until[lang] }}
                                          <i v-if="location==1">17:30</i><i v-if="location==2">17:30</i>
                                         </span>
                                    <em v-bind:class="{disabled: selectionOptions[0].timeranges.after != config.serviceIdWeekAfter}">{{ weekAfterService.relevantPrice.price | francs }}</em>
                                </li>
                                <li>
                                    <div>
                                        <p-radio @change="checkConditions" type="radio" name="after-day-week" id="afterplusweek" :value="config.serviceIdWeekAfterPlus" class="p-default p-round p-fill level2" v-model="selectionOptions[0].timeranges.after">
                                            {{ trans.global.alldays[lang] }} {{ trans.global.until[lang] }} 18:30
                                        </p-radio>
                                    </div>
                                    <span>{{ trans.global.from[lang] }}

                                         <i v-if="location==1">15:45</i><i v-if="location==2">15:30</i>

                                         {{ trans.global.until[lang] }} 18:30</span>
                                    <em v-bind:class="{disabled:selectionOptions[0].timeranges.after != config.serviceIdWeekAfterPlus}">{{ weekAfterPlusService.relevantPrice.price | francs }}</em>
                                </li>




                                <li style="margin-bottom:2em">
                                    <div>
                                        <p-radio type="radio" name="after-day-week" id="afterdays" :value="false" class="p-default p-round p-fill level2" v-model="selectionOptions[0].timeranges.after">
                                            {{ trans.global.some_days[lang] }}
                                        </p-radio>
                                    </div>
                                    <em v-bind:class="{disabled:selectionOptions[0].timeranges.after}">{{ priceAfterDays | francs }}</em>
                                    <div class="noflex" v-if="selectionOptions[0].timeranges.after === false" >
                                        <p class="info">{{ trans.daycare.choose_daystime[lang] }} </p>

                                        <div v-for="day in days" :key="day.id" class="weekdaysoption">

                                            <div v-bind:class="{noborder:day.id == 'mi' && selectionOptions[day.id].timeranges.after}">
                                                <div class="select-wrapper" v-bind:class="{disabled:!selectionOptions[day.id].timeranges.after}">
                                                    <select v-if="day.id != 'mi'" v-model="selectionOptions[day.id].timeranges.after">
                                                        <option :value="null">{{ day.name }} - {{ trans.daycare.no_care[lang] }}</option>
                                                        <option v-if="location == 1" :value="config.serviceIdDayAfter" v-html="day.name + ' ' + trans.global.from[lang] + ' 15:45 '  + trans.global.until[lang] + ' 17.30'"></option>
                                                        <option v-if="location == 1" :value="config.serviceIdDayAfterPlus" v-html="day.name + ' '+ trans.global.from[lang] + ' ' + ' 15:45 '  + trans.global.until[lang] + ' 18.30'"></option>
                                                        <option v-if="location == 2" :value="config.serviceIdDayAfter" v-html="day.name + ' ' + trans.global.from[lang] + ' 15:30 '  + trans.global.until[lang] + ' 17.30'"></option>
                                                        <option v-if="location == 2" :value="config.serviceIdDayAfterPlus" v-html="day.name + ' '+ trans.global.from[lang] + ' ' + ' 15:30 '  + trans.global.until[lang] + ' 18.30'"></option>
                                                    </select>
                                                    <select v-else v-model="selectionOptions[day.id].timeranges.after">
                                                        <option :value="null">{{ day.name }} - {{ trans.daycare.no_care[lang] }}</option>
                                                        <option v-if="location == 1" :value="config.serviceIdDayAfterMiA" v-html="day.name + ' ' + trans.global.from[lang] + ' 12:00 ' + trans.global.until[lang] + ' 13.15'"></option>
                                                        <option v-if="location == 1" :value="config.serviceIdDayAfterMiB" v-html="day.name + ' ' + trans.global.from[lang] + ' 12:00 ' + trans.global.until[lang] + ' 15.45'"></option>
                                                        <option v-if="location == 1" :value="config.serviceIdDayAfterMiC" v-html="day.name + ' ' + trans.global.from[lang] + ' 12:00 ' + trans.global.until[lang] + ' 17.30'"></option>
                                                        <option v-if="location == 1" :value="config.serviceIdDayAfterMiD" v-html="day.name + ' ' + trans.global.from[lang] + ' 12:00 ' + trans.global.until[lang] + ' 18.30'"></option>
                                                        <option v-if="location == 2" :value="config.serviceIdDayAfterMiA" v-html="day.name + ' ' + trans.global.from[lang] + ' 12:00 ' + trans.global.until[lang] + ' 13.30'"></option>
                                                        <option v-if="location == 2" :value="config.serviceIdDayAfterMiB" v-html="day.name + ' ' + trans.global.from[lang] + ' 12:00 ' + trans.global.until[lang] + ' 15.30'"></option>
                                                        <option v-if="location == 2" :value="config.serviceIdDayAfterMiC" v-html="day.name + ' ' + trans.global.from[lang] + ' 12:00 ' + trans.global.until[lang] + ' 17.30'"></option>
                                                        <option v-if="location == 2" :value="config.serviceIdDayAfterMiD" v-html="day.name + ' ' + trans.global.from[lang] + ' 12:00 ' + trans.global.until[lang] + ' 18.30'"></option>
                                                    </select>
                                                </div>

                                                <span v-if="priceAfterSingleDays[day.id]">{{ trans.global.chf_month[lang] }}</span>
                                                <em v-if="priceAfterSingleDays[day.id]">{{ priceAfterSingleDays[day.id] | francs}}</em>
                                                <em v-else></em>
                                            </div>

                                            <div v-if="day.id == 'mi' && selectionOptions[day.id].timeranges.after">
                                                <label style="display: block;padding-top: 0.6em;" @click="selectionOptions[day.id].lunch = selectionOptions[day.id].lunch ? false : true" :for="'lunch_' + day.id">
                                                    <span v-bind:class="[selectionOptions[day.id].lunch  ? 'checkbox checked' : 'checkbox', ]"></span>
                                                    <img src="/assets/img/icon-lunch.svg"/>

                                                    {{ trans.global.pizza[lang] }}
                                                </label>
                                                <span v-if="priceAfterSingleDays[day.id] && priceLunch > 0">{{ trans.global.chf_month[lang] }}<br>{{ trans.global.mwst[lang] }} 8.1%</span>
                                                <em v-if="priceLunch">{{ priceLunch | francs}}</em>
                                            </div>

                                        </div>
                                    </div>

                                </li>

                                <!-- Pizza Hot lunch (if all days selected) -->
                                <li  v-if="selectionOptions[0].timeranges.after == config.serviceIdWeekAfterPlus || selectionOptions[0].timeranges.after == config.serviceIdWeekAfter">
                                    <div style="width:100%;display:flex;justify-content:space-between" class="noborder">
                                        <label style="display: block;padding-top: 0.6em;font-size:0.9em" @click="selectionOptions['mi'].lunch = selectionOptions['mi'].lunch ? false : true" for="lunch_mi">
                                            <span style="width:calc(1em + 2px) !important;height:calc(1em + 2px)  !important;min-width:auto;min-height:auto;" v-bind:class="[selectionOptions['mi'].lunch  ? 'checkbox checked' : 'checkbox', ]"></span>
                                            <img src="/assets/img/icon-lunch.svg"/>

                                            {{ trans.global.pizza[lang] }} ({{ trans.global.mittwoch[lang] }})
                                        </label>
                                        <span v-if="priceLunch > 0" style="font-size:min(max(12px, 0.888vw), 19px)">{{ trans.global.chf_month[lang] }}<br>{{ trans.global.mwst[lang] }} 8.1%</span>
                                        <em v-if="priceLunch">{{ priceLunch | francs}}</em>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <div class="summarybox-wrapper" v-if="priceSummary > 0">
                    <br><br>
                    <div class="summarybox">
                        <label>{{ trans.global.chf_month_total[lang] }}:</label>
                        <em>{{ priceSummary | francs}}</em>
                    </div>
                </div>
                <div class="applicationbox" v-if="priceSummary > 0">
                    <p>{{ trans.global.c2a_finish[lang] }}</p>
                    <button class="btn btnoutline" v-on:click="prepareData('pdf')">{{ trans.global.downloadpdf[lang] }}</button>
                    <button class="btn" v-if="appmode=='offer'" v-on:click="prepareData('app')">{{ trans.global.register[lang] }}</button>
                    <button class="btn" v-if="appmode=='change'" v-on:click="prepareData('app')">{{ trans.global.confirm[lang] }}</button>

                </div>


            </section>

        </div>

        <div class="teaser-wrapper">
            <h3 class="title"></h3>
            <div class="grid">
                <div class="teaser">
                    <p>{{ trans.teaser.holidays.text[lang] }}</p>
                    <a :href="trans.teaser.holidays.link[location][lang]" target="_blank">{{ trans.teaser.holidays.linktext[lang] }}</a>
                </div>
                <div class="teaser">
                    <p>{{ trans.teaser.afterschool.text[lang] }}</p>
                    <a :href="trans.teaser.afterschool.link[location][lang]" target="_blank">{{ trans.teaser.afterschool.linktext[lang] }}</a>
                </div>
            </div>
        </div>

    </div>



</div>


</template>
<script>

    import * as helpers from "./helpers.js";
    import * as methods from "./methods.js";

    export default {

        // template: require('././DaycareTemplateComponent.html'),

        data: function() {

            let endBeforeLunch = '11:45';
            let endAfterLunch = '13:30';

            return  {
                days: [

                    { id: 'mo', name: this.trans.global.monday[this.lang], lunch: true },
                    { id: 'di', name: this.trans.global.tuesday[this.lang], lunch: true },
                    { id: 'mi', name: this.trans.global.wednesday[this.lang], lunch: false },
                    { id: 'do', name: this.trans.global.thursday[this.lang], lunch: true },
                    { id: 'fr', name: this.trans.global.friday[this.lang], lunch: true }

                ],

                config:{
                    sectorIds: [ 1 , 5 ], // Daycare, Sonstiges
                    serviceIdWeekBefore: 1,
                    serviceIdWeekAfter: 2,
                    serviceIdWeekAfterPlus: 3,
                    serviceIdDayBefore: 4,
                    serviceIdDayAfter: 5,
                    serviceIdDayAfterPlus: 6,
                    serviceIdDayAfterMiA: 7,
                    serviceIdDayAfterMiB: 8,
                    serviceIdDayAfterMiC: 9,
                    serviceIdDayAfterMiD: 18,
                    serviceIdLunchs: 17,
                    endBeforeLunch: endBeforeLunch,
                    endAfterLunch: endAfterLunch,
                },

                selectionOptions: {
                    0: {
                        type: 'week',
                        timeranges: {
                            before: false,
                            after: false
                        },
                        lunchMi: false
                    },
                    'mo': {
                        type: 'day',
                        active: false,
                        timeranges: {
                            before: null,
                            after: null
                        },
                        lunch: false
                    },
                    'di': {
                        type: 'day',
                        active: false,
                        timeranges: {
                            before: null,
                            after: null
                        },
                        lunch: false
                    },
                    'mi': {
                        type: 'day',
                        active: false,
                        timeranges: {
                            before: null,
                            after: null
                        },
                        lunch: false
                    },
                    'do': {
                        type: 'day',
                        active: false,
                        timeranges: {
                            before: null,
                            after: null
                        },
                        lunch: false
                    },
                    'fr': {
                        type: 'day',
                        active: false,
                        timeranges: {
                            before: null,
                            after: null
                        },
                        lunch: false
                    }
                },

                mainservice: null,
                services: [],
                errors: [],
                selections: [],
                selectionsOrigin: [],
                selectionsToSubmit: [],
                deletedTimetables: [],
                mode: 'week',
                dataIsInit: false,
                area:{
                    before: false,
                    after: false,
                }

            }
        },
        props: {
            session: {
                type: String,
                required: true
            },
            location: {
                type: Number,
                required: true
            },
            lang: {
                type: String,
                required: true
            },
            appmode: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },

        },
        components: {

        },
        computed: {
            lunchService: function () {
                let id = this.config.serviceIdLunchs;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            weekBeforeService: function () {
                let id = this.config.serviceIdWeekBefore;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            dayBeforeService: function () {
                let id = this.config.serviceIdDayBefore;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            dayAfterService: function () {
                let id = this.config.serviceIdDayAfter;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            dayAfterPlusService: function () {
                let id = this.config.serviceIdDayAfterPlus;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            dayAfterMiAService: function () {
                let id = this.config.serviceIdDayAfterMiA;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            dayAfterMiBService: function () {
                let id = this.config.serviceIdDayAfterMiB;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            dayAfterMiCService: function () {
                let id = this.config.serviceIdDayAfterMiC;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            dayAfterMiDService: function () {
                let id = this.config.serviceIdDayAfterMiD;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            weekAfterService: function () {
                let id = this.config.serviceIdWeekAfter;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            weekAfterPlusService: function () {
                let id = this.config.serviceIdWeekAfterPlus;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            lunchSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return item.service_id == app.config.serviceIdLunchs;
                });
            },
            modulRelevantSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    let found = app.services.find(element => element.id == item.service_id);
                    return found !== undefined
                });
            },
            choosenSelectionWeek: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds['week'] == item.id;
                })[0];
            },
            choosenSelectionDayBefore: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds['dayBefore'] == item.id;
                })[0];
            },
            choosenSelectionDayAfter: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds['dayAfter'] == item.id;
                })[0];
            },
            choosenDays: function () {
                let app = this;
                let days = [];
                for(var index in app.selectionOptions) {
                    if(app.selectionOptions[index].type == 'day' && app.selectionOptions[index].active === true){
                        days.push(app.selectionOptions[index]);
                    }
                }
                return  days;
            },
            priceBeforeDays: function () {
                let app = this;
                let price = 0;
                if(app.area.before)
                {
                    for(var index in app.selectionOptions) {
                        if(app.selectionOptions[index].type == 'day' && app.selectionOptions[index].timeranges.before){
                        price = price + app.dayBeforeService.relevantPrice.price_brutto
                        }
                    }
                }
                return price;
            },
            priceAfterDays: function () {
                let app = this;
                let price = 0;
                if(app.area.after)
                {
                    for(var index in app.selectionOptions) {
                        if(app.selectionOptions[index].type == 'day' && app.selectionOptions[index].timeranges.after){
                        var service =  this.services.filter(function(item) {
                                return item.id == app.selectionOptions[index].timeranges.after;
                            })[0];
                            price = price + service.relevantPrice.price_brutto
                        }
                    }
                }
                return price;
            },

            priceAfterSingleDays: function () {
                let app = this;
                var prices = [];

                if(app.area.after)
                {
                    for(var index in app.selectionOptions) {
                        if(app.selectionOptions[index].timeranges.after){
                            var service =  this.services.filter(function(item) {
                                return item.id == app.selectionOptions[index].timeranges.after;
                            })[0];
                            prices[index] = service.relevantPrice.price_brutto;
                        }
                    }
                }


                return prices;
            },

            priceLunch: function () {
                let app = this;
                var price = 0;
                if(app.area.after)
                {
                    if(app.selectionOptions['mi'].lunch)
                    {
                        price = app.lunchService.relevantPrice.price_brutto
                    }
                }

                return price;
            },


            price: function () {
                let app = this;
                let price = 0;
                if(app.selectionOptions[0].timeranges.before)
                {
                    price = price + app.weekBeforeService.relevantPrice.price_brutto;
                }
                else
                {
                     price = price + app.priceBeforeDays;
                }

                if(app.selectionOptions[0].timeranges.after)
                {
                    var service =  this.services.filter(function(item) {
                        return item.id == app.selectionOptions[0].timeranges.after;
                    })[0];
                    price = price + service.relevantPrice.price_brutto;
                }
                else
                {
                     price = price + app.priceAfterDays;
                }

                return price
            },
            priceSummary: function () {
                 return this.price + this.priceLunch;
            }


        },
        watch: {
            mode: function(){
                this.setLunches()
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                let app = this;
                // load for each sector the services
                axios.get('/api/services/bysectors/' + this.config.sectorIds.join() + '/' + this.location)
                .then(response => {
                    this.services = this.services.concat(response.data);
                    axios.get('/api/session/data/' + this.session )
                        .then(response => {
                            // this.selections = response.data.selections.filter(function(item) {
                            //     return item.location_id == app.location;
                            // });
                             this.selections = [];
                            this.selectionsOrigin = response.data.selections.filter(function(item) {
                                return item.location_id == app.location;
                            });
                            app.dataInit();
                        })
                        .catch(e => {
                            this.errors.push(e)
                        });
                })
                .catch(e => {
                    this.errors.push(e)
                });
            },

            dataInit() {

                let app = this;

                let weekBefore = this.getSingleSelection( [ app.config.serviceIdWeekBefore] );
                let weekAfter = this.getSingleSelection( [ app.config.serviceIdWeekAfter] );
                let weekAfterPlus = this.getSingleSelection( [ app.config.serviceIdWeekAfterPlus] );
                let dayBefore = this.getSingleSelection( [ app.config.serviceIdDayBefore ] );
                let dayAfter = this.getSingleSelection( [ app.config.serviceIdDayAfter ] );
                let dayAfterPlus = this.getSingleSelection( [ app.config.serviceIdDayAfterPlus ] );
                let dayAfterMiA = this.getSingleSelection( [ app.config.serviceIdDayAfterMiA ] );
                let dayAfterMiB = this.getSingleSelection( [ app.config.serviceIdDayAfterMiB ] );
                let dayAfterMiC = this.getSingleSelection( [ app.config.serviceIdDayAfterMiC ] );
                let dayAfterMiD = this.getSingleSelection( [ app.config.serviceIdDayAfterMiD ] );


                if(weekBefore[0])
                {
                    app.selectionOptions[0].timeranges.before = app.config.serviceIdWeekBefore;
                    app.area.before = true;
                }
                if(dayBefore[0])
                {
                    app.area.before = true;
                }
                if(weekAfter[0])
                {
                    app.selectionOptions[0].timeranges.after = app.config.serviceIdWeekAfter;
                    app.area.after = true;
                }
                if(weekAfterPlus[0])
                {
                    app.selectionOptions[0].timeranges.after = app.config.serviceIdWeekAfterPlus;
                    app.area.after = true;
                }

                if(dayBefore.length > 0 ||
                    dayAfter.length > 0 ||
                    dayAfterPlus.length > 0 ||
                    dayAfterMiA.length > 0 ||
                    dayAfterMiB.length > 0 ||
                    dayAfterMiC.length > 0 ||
                    dayAfterMiD.length > 0 )
                {
                    app.mode = 'days';
                }

                if(dayBefore[0])
                {
                    for(let i = 0; i < dayBefore[0].timetables.length; i++)
                    {
                        app.$set(app.selectionOptions[dayBefore[0].timetables[i].weekday], 'active', true);
                        app.$set(app.selectionOptions[dayBefore[0].timetables[i].weekday].timeranges, 'before', dayBefore[0].service_id)
                    }
                }
                if(dayAfter[0])
                {
                    for(let i = 0; i < dayAfter[0].timetables.length; i++)
                    {
                        app.$set(app.selectionOptions[dayAfter[0].timetables[i].weekday], 'active', true);
                        app.$set(app.selectionOptions[dayAfter[0].timetables[i].weekday].timeranges, 'after', dayAfter[0].service_id)
                    }
                }
                if(dayAfterPlus[0])
                {
                    for(let i = 0; i < dayAfterPlus[0].timetables.length; i++)
                    {
                        app.$set(app.selectionOptions[dayAfterPlus[0].timetables[i].weekday], 'active', true);
                        app.$set(app.selectionOptions[dayAfterPlus[0].timetables[i].weekday].timeranges, 'after', dayAfterPlus[0].service_id)
                    }
                }
                if(dayAfterMiA[0])
                {
                    app.$set(app.selectionOptions['mi'], 'active', true);
                    app.$set(app.selectionOptions['mi'].timeranges, 'after', dayAfterMiA[0].service_id)
                }
                if(dayAfterMiB[0])
                {
                    app.$set(app.selectionOptions['mi'], 'active', true);
                    app.$set(app.selectionOptions['mi'].timeranges, 'after', dayAfterMiB[0].service_id)
                }
                if(dayAfterMiC[0])
                {
                    app.$set(app.selectionOptions['mi'], 'active', true);
                    app.$set(app.selectionOptions['mi'].timeranges, 'after', dayAfterMiC[0].service_id)
                }
                if(dayAfterMiD[0])
                {
                    app.$set(app.selectionOptions['mi'], 'active', true);
                    app.$set(app.selectionOptions['mi'].timeranges, 'after', dayAfterMiD[0].service_id)
                }

                // achtung manual fix
                // app.selectionOptions[0].timeranges.before = app.config.serviceIdWeekBefore;
                // app.selectionOptions[0].timeranges.after = app.config.serviceIdWeekAfter;

                app.setLunches();
                app.dataIsInit = true;

            },

           addNewSelectionsAndTimetables(serviceId,weekday = null)
           {

                let app = this;

                let service =  this.services.filter(function(item) {
                    return item.id == serviceId;
                })[0];


                if(app.config.serviceIdWeekAfter == serviceId){ // if service WeekAfter delete WeekAfterPlus

                    for (let i = 0; i < app.selections.length; i++) {
                        if(
                            app.selections[i].service_id == app.config.serviceIdWeekAfterPlus ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterPlus ||
                            app.selections[i].service_id == app.config.serviceIdDayAfter ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterMiA ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterMiB ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterMiC ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterMiD

                            ) {
                             app.selections.splice(i, 1);
                        }
                    }
                }
                if(app.config.serviceIdWeekAfterPlus == serviceId){ // if service WeekAfterPlus delete WeekAfter
                    for (let i = 0; i < app.selections.length; i++) {
                        if(
                            app.selections[i].service_id == app.config.serviceIdWeekAfter ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterPlus ||
                            app.selections[i].service_id == app.config.serviceIdDayAfter ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterMiA ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterMiB ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterMiC ||
                            app.selections[i].service_id == app.config.serviceIdDayAfterMiD
                        ) {
                            app.selections.splice(i,1);
                        }
                    }
                }
                if(app.config.serviceIdWeekBefore == serviceId){ // if service WeekBefore delete serviceIdDayBefore
                    for (let i = 0; i < app.selections.length; i++) {
                        if(app.selections[i].service_id == app.config.serviceIdDayBefore) {
                            app.selections.splice(i,1);
                        }
                    }
                }


                if(serviceId == app.config.serviceIdDayBefore) // delete serviceIdWeekBefore
                {
                    for (let i = 0; i < app.selections.length; i++) {
                        if(app.selections[i].service_id == app.config.serviceIdWeekBefore) {
                            app.selections.splice(i, 1);
                        }
                    }
                }
                if(serviceId == app.config.serviceIdDayAfter  // delete serviceIdWeekAfter
                    || serviceId == app.config.serviceIdDayAfterPlus
                    || serviceId == app.config.serviceIdDayAfterMiA
                    || serviceId == app.config.serviceIdDayAfterMiB
                    || serviceId == app.config.serviceIdDayAfterMiC
                    || serviceId == app.config.serviceIdDayAfterMiD
                )
                {
                    for (let i = 0; i < app.selections.length; i++) {
                        if(app.selections[i].service_id == app.config.serviceIdWeekAfter) {
                            app.selections.splice(i, 1);
                        }
                    }
                }

                var selection = app.selections.filter(function(item){
                    return item.service_id == service.id
                })[0];

                if(selection === undefined)
                {
                    selection = this.createNewSelection(service.id)
                }


                if(weekday) // else week
                {
                    let existingTimetable = selection.timetables.filter(function(item){
                        return item.weekday == weekday
                    })
                    if(existingTimetable.length == 0){
                        selection.timetables.push(
                            {
                                id: this.generateString(12),
                                weekday: weekday,
                                selection_id: selection.id,
                            }
                        )
                    }
                }
           },

            prepareData(next='pdf')
            {
                let app = this;

                var selectionsToSubmit = [];

                app.selections = [];

                /// manage timetables for individual days

                for(var index in app.selectionOptions) {


                    if(app.selectionOptions[index].type == 'day'){
                        if(app.selectionOptions[index].timeranges.before)
                        {
                            app.addNewSelectionsAndTimetables(app.dayBeforeService.id,index)
                        }
                        if(app.selectionOptions[index].timeranges.after)
                        {
                            app.addNewSelectionsAndTimetables(app.selectionOptions[index].timeranges.after,index)
                        }
                    }
                    if(app.selectionOptions[index].type == 'week' && app.selectionOptions[index].timeranges.before){
                        app.addNewSelectionsAndTimetables(app.weekBeforeService.id,index);
                    }
                    if(app.selectionOptions[index].type == 'week' && app.selectionOptions[index].timeranges.after){
                        app.addNewSelectionsAndTimetables(app.selectionOptions[index].timeranges.after,index);
                    }

                }

                if(app.selectionOptions['mi'].lunch){
                    this.createNewSelection(app.config.serviceIdLunchs);
                };



                app.storeData(app.modulRelevantSelections,1,next);

                this.$forceUpdate();

            },


            checkConditions(){
                 let app = this;
                 if(app.selectionOptions[0].timeranges.before)
                 {
                       for(var index in app.selectionOptions) {
                            if(app.selectionOptions[index].type == 'day'){
                              app.selectionOptions[index].timeranges.before = null
                            }
                        }
                 }
                if(app.selectionOptions[0].timeranges.after)
                 {
                       for(var index in app.selectionOptions) {
                            if(app.selectionOptions[index].type == 'day'){
                              app.selectionOptions[index].timeranges.after = null
                            }
                        }
                 }
            },

            setLunches(){
                let app = this;

                    let lunchSelection = app.lunchSelections.find(element => element.timetables[0].weekday == 'mi');

                    if(lunchSelection)
                    {
                        app.selectionOptions['mi'].lunch = true;
                        app.selectionOptions[0].lunchMi = true;
                    }
                    else
                    {
                        app.selectionOptions['mi'].lunch = false;
                        app.selectionOptions[0].lunchMi = false;
                    }
            },

            dayWeekSwitch(selection){
                let app = this;
                if(selection == 'days')
                {
                    app.area.beforeDays = true;
                    app.selectionOptions[0].timeranges.before = false;
                }
                 if(selection == 'week')
                {
                    app.selectionOptions[0].timeranges.before = app.config.serviceIdWeekBefore;
                    app.area.beforeDays = false;
                }
            },

            ...helpers,
            ...methods,

        }

    }
</script>
